/*=========================================================================================
  File Name: moduleEmailMutations.js
  Description: Email Module Mutations
  ----------------------------------------------------------------------------------------

==========================================================================================*/


export default {
  SET_EMAIL_SEARCH_QUERY (state, query) {
    state.mailSearchQuery = query
  },
  SET_EMAIL_AND_FOLDER_SELECT(state, data) {
    // console.log('SET_EMAIL_AND_FOLDER_SELECT')
    // console.log('data')
    // console.log(data)
    state.accountEmailSelect = data.email
    state.folderSelect = data.folder
  },
  CLEAR_MAIL_SELECTED(state){
    state.mailSelected = []
  },
  SET_MAILS (state, info) {
    state.mails = []
    let mails = info.data
    // console.log('mails')
    // console.log(mails)
    let email = info.email
    let folder = info.folder
    // console.log('email')
    // console.log(email)
    // console.log('folder')
    // console.log(folder)

    mails = mails.reverse()
    mails.map(mail => {
      let mailResult;
      if (mail['mail_overview'] && mail['mail_detail']) {
        let overview = mail['mail_overview']
        let detail = mail['mail_detail']
        let flags = detail['flags']
        mailResult = {
          id: overview.sequence,
          uid: overview.uid,
          sender: overview.sender[0].mail,
          sender_name: overview.sender[0].personal,
          to: overview.to != null ? overview.to.map(info => {
            return info.mail
          }) : [],
          // Todo: image profile complete latter
          img: require(`@/assets/images/portrait/small/avatar-s-` + (overview.sequence % 26 + 1) + `.jpg`),
          // Todo: subject can error character not is utf-8 in some mail 
          subject: overview.subject,
          message: detail.bodies.text,
          attachments: detail.attachments,
          isStarred: flags.hasOwnProperty('flagged') ? true: false ,
          unread: flags.hasOwnProperty('seen') ? false: true,
          time: overview.time,
          date: overview.date,
          // Todo: Labels
          labels: ['personal'],
          replies: [],
          // Todo: replies is complete latter
          // replies: overview.sequence,
          // Todo: mailFolder can not use, complete latter
          mailFolder: folder,
          ownerMail: email,
          // Todo: cc, bcc is required in in mail detail 
          // cc: [],
          // bcc: [],
        }
      }
      state.mails.push(mailResult)
    })
  },

  SET_MAIL_SELECTED (state, payload, folder, email) {
    state.mailSelected = []
    let data = payload.overview
    let detail = payload.mail_detail
    state.mailSelected.push({
      id: parseInt(data.sequence),
      uid: data.uid,
      to: data.to ? data.to.map(info =>{
        return info.mail;
      }) : [],
      sender: data.sender[0].mail,
      sender_name: data.sender[0].personal,
      img: require(`@/assets/images/portrait/small/avatar-s-` + (data.sequence % 26 + 1) + `.jpg`),
      subject: data.subject,
      message: detail.bodies.html ? detail.bodies.html : detail.bodies.text,
      isStarred: data.sequence %3 == 0 ? true : false,
      time: data.date,
      unread: detail.flags.seen === "Seen" ? false : true,
      mailFolder: data.sequence%2==0 ? ['inbox'] : ['spam'],
      replies: [
        state.mails[2]
      ],
      attachments: detail.attachments,
      labels: data.sequence%2==0 ? ['personal']:['important','private'],
      cc: [],
      folder: folder,
      accountMail: email
    })
  },
  // SET_MAILS (state, mails) {
  //   state.mails = mails
  // },
  // SET_TAGS (state, tags) {
  //   state.mailTags = tags
  // },
  SET_META (state) {
    return new Promise((resolve, reject) => {
      const countUnreadMailFolders = ['inbox', 'spam']

      state.mails.forEach((mail) => {

        // Count unread mails
        if (mail.unread) {

          // Add mail id
          if (countUnreadMailFolders.includes(mail.mailFolder)) {
            state.meta.unreadMails.folder[mail.mailFolder] ? state.meta.unreadMails.folder[mail.mailFolder].push(mail.id) : state.meta.unreadMails.folder[mail.mailFolder] = [mail.id]
          }

          // Add mail id
          mail.labels.forEach((label) => {
            state.meta.unreadMails.label[label] ? state.meta.unreadMails.label[label].push(mail.id) : state.meta.unreadMails.label[label] = [mail.id]
          })
        }

        // Get draft mail count
        if (mail.mailFolder === 'drafts') state.meta.draftMails.push(mail.id)
      })
    })
  },
  UPDATE_MAIL_FILTER (state, filterName) {
    state.mail_filter = filterName
  },
  // UPDATE_LABELS (state, payload) {
  //   payload.mails.forEach((mailId) => {
  //     const mailIndex = state.mails.findIndex((mail) => mail.id === mailId)
  //     const index = state.mails[mailIndex].labels.indexOf(payload.label)

  //     if (index === -1) state.mails[mailIndex].labels.push(payload.label)
  //     else state.mails[mailIndex].labels.splice(index, 1)
  //   })
  // },
  // SET_LABELS (state, payload) {
  //   state.mails.find((mail) => mail.id === payload.mailId).labels = payload.labels
  // },
  SET_UNREAD (state, payload) {
    return new Promise((resolve, reject) => {
      const mailsToUpdate = JSON.parse(payload.data).emailIds

      mailsToUpdate.forEach((mailId) => {
        const mailIndex = state.mails.findIndex((mail) => mail.id == mailId)
        state.mails[mailIndex].unread = JSON.parse(payload.data).unreadFlag
      })
      payload.emailIds.forEach((mailId) => {
        const mailIndex = state.mails.findIndex((mail) => mail.id === mailId)
        if (mailIndex !== -1) state.mails[mailIndex].unread = payload.unreadFlag
      })
      // Remove this if you are getting meta like us
      // Use your own method to update email meta if you are fetching email meta
      commit('UPDATE_UNREAD_META', payload)
      resolve({ data: {} })
    })
  },

  MOVE_MAILS_TO (state, payload) {
    payload.emailIds.forEach((mailId) => {
      const mailIndex = state.mails.findIndex((mail) => mail.id === mailId)

      // Update draft meta
      // If moving from draft mailFolder decrease draft meta by removing mailId
      if (state.mails[mailIndex].mailFolder === 'draft') {
        state.meta.draftMails.splice(state.meta.draftMails.findIndex(i => i === mailId), 1)
      }
      // Else increase by pushing mailId
      if (payload.to === 'draft') {
        state.meta.draftMails.push(mailId)
      }

      state.mails[mailIndex].mailFolder = payload.to
    })
  },

  TOGGLE_IS_MAIL_STARRED (state, payload) {
    state.mails.find((mail) => mail.id === payload.mailId).isStarred = payload.value
  },
  TOGGLE_IS_MAIL_SELECT_STARRED (state, payload) {
    state.mailSelected.find((mail) => mail.id === payload.mailId).isStarred = payload.value
  },

  // If your process of fetching is different than ours. Please update action and mutation
  // Maybe this mutation is redundant for you. Feel free to remove it.
  UPDATE_UNREAD_META (state, payload) {

    // Loop over email meta
    for (const folder in state.meta.unreadMails.folder) {

      // If folder is same as current filter
      if (folder === state.mail_filter) {

        if (payload.unreadFlag) {

          // If unread flag is true - increase count
          payload.emailIds.forEach((mailId) => {
            if (state.meta.unreadMails.folder[folder].indexOf(mailId) === -1) state.meta.unreadMails.folder[folder].push(mailId)
          })
        } else {

          // else reduce unread mails count
          payload.emailIds.forEach((mailId) => {
            const mailIdIndex = state.meta.unreadMails.folder[folder].indexOf(mailId)
            if (mailIdIndex !== -1) state.meta.unreadMails.folder[folder].splice(mailIdIndex, 1)
          })
        }

      }
    }
  },
  UPDATE_UNREAD_META_ON_MOVE (state, payload) {

    // Updating Draft meta is handled by "MOVE_MAILS_TO" mutation

    payload.emailIds.forEach((mailId) => {
      const mail = state.mails.find((mail) => mail.id === mailId)

      if (mail.unread) {
        const cf_unread_mails = state.meta.unreadMails.folder[state.mail_filter]
        if (cf_unread_mails) {
          cf_unread_mails.splice(cf_unread_mails.indexOf(mailId), 1)
        }
        if (state.meta.unreadMails.folder[payload.to]) state.meta.unreadMails.folder[payload.to].push(mailId)
      }
    })
  },
  SET_MAIL_FOLDERS(state, payload){
    state.mailFolders = payload;
  },
}
